import React from 'react';
import { LegacyButtonVariant } from 'apps/sigma2-ui/src/components/ui/Buttons';
import { LegacyButton } from 'apps/sigma2-ui/src/components/ui/LegacyButton';

export const CopilotLineGraphTooltipButton: React.FC<{
  variant: LegacyButtonVariant;
  onClick: () => void;
  icon: React.ReactNode;
  text: string;
}> = ({ variant, onClick, text, icon }) => {
  return (
    <LegacyButton
      variant={variant}
      className="mt-4 flex items-center font-sans"
      onClick={onClick}
    >
      <div className="flex flex-row items-center gap-2">
        {icon}
        <span className="text-sm normal-case">{text}</span>
      </div>
    </LegacyButton>
  );
};
